'use client';

/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { useDisclosure } from '@chakra-ui/react';

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    checkMobile(); // Initial check

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  return { isMobile, isOpen, onOpen, onClose };
};
